var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var DailyDepartmentNotificationNode_1, DailyDepartmentNotificationBatchNode_1;
import { GraphQLLocalDate } from "graphql-scalars";
import { Err, Ok } from "ts-results-es";
import { Field, ObjectType, registerEnumType } from "type-graphql";
import { InvalidArgumentError } from "../../error/direct.js";
import { Node } from "../relay.js";
import { DateTimeScalar } from "../scalars/DateTimeISO.js";
import { GlobalIdScalar } from "../scalars/GlobalId.js";
import { Resource } from "./Resource.js";
import { SolicitationCodeNode } from "./SolicitationCode.js";
export const BatchType = {
    /**
     * Legacy entries from DBFunds
     */
    DBFunds: "DBFunds",
    /**
     * Check batches (C) include gifts to UK mailed directly to the Office of Development or to Gift Receiving, generally response to a phonathon solicitation
     */
    Check: "Check",
    /**
     * Transmittal batches (T) include gifts to UK mailed directly to another department.
     */
    Transmittal: "Transmittal",
    /**
     * Credit Card batches (D) include credit card gifts approved by Gift Receiving office or Phonathon/Annual Giving, those made by a donor through the Office of Development online giving page, or by recurring subscription
     */
    CreditCard: "CreditCard",
    /**
     * ACH batches (A) include gifts set-up by the Gift Receiving office as a recurring subscription
     */
    ACH: "ACH",
    /**
     * Non-cash batches (N) include any gift to UK that is not received, processed or approved by the Gift Receiving office – gift was deposited by another department or gift-in-kind
     */
    NonCash: "NonCash",
    /**
     * Payroll Deduction batches (X) include gifts from UK employees through bi-weekly or monthly payroll deductions
     */
    PayrollDeduction: "PayrollDeduction",
    /**
     * P
     */
    P: "P",
    /**
     * Fallback batch type for when the batch type is unknown
     */
    Unknown: "Unknown",
};
registerEnumType(BatchType, {
    name: "BatchType",
});
export const BatchTypeCodes = {
    [BatchType.Check]: "C",
    [BatchType.Transmittal]: "T",
    [BatchType.CreditCard]: "D",
    [BatchType.ACH]: "A",
    [BatchType.NonCash]: "N",
    [BatchType.PayrollDeduction]: "X",
};
export function extractDDNBatchType(batchId) {
    let code = "";
    for (let i = batchId.length - 1; i >= 0; i--) {
        const letter = batchId[i];
        if (!letter) {
            return Err(new InvalidArgumentError("Invalid batch ID"));
        }
        // Skip anything that isn't an uppercase letter
        if (letter < "A" || letter > "Z") {
            if (code.length > 0) {
                break;
            }
            else {
                continue;
            }
        }
        code = letter + code;
    }
    switch (code) {
        case "C": {
            return Ok(BatchType.Check);
        }
        case "T": {
            return Ok(BatchType.Transmittal);
        }
        case "D": {
            return Ok(BatchType.CreditCard);
        }
        case "A": {
            return Ok(BatchType.ACH);
        }
        case "N": {
            return Ok(BatchType.NonCash);
        }
        case "X": {
            return Ok(BatchType.PayrollDeduction);
        }
        case "P": {
            return Ok(BatchType.P);
        }
        default: {
            console.warn(`Unknown batch type: ${code}`);
            return Ok(BatchType.Unknown);
        }
    }
}
export function stringifyDDNBatchType(batchType) {
    switch (batchType) {
        case BatchType.CreditCard: {
            return "Credit Card";
        }
        case BatchType.NonCash: {
            return "Non-cash";
        }
        case BatchType.PayrollDeduction: {
            return "Payroll Deduction";
        }
        default: {
            return batchType;
        }
    }
}
let DailyDepartmentNotificationNode = DailyDepartmentNotificationNode_1 = class DailyDepartmentNotificationNode extends Resource {
    id;
    division;
    department;
    effectiveDate;
    processDate;
    pledgedDate;
    transactionDate;
    transactionType;
    donor1Amount;
    donor2Amount;
    combinedAmount;
    pledgedAmount;
    accountNumber;
    accountName;
    holdingDestination;
    comment;
    secShares;
    secType;
    gikType;
    gikDescription;
    onlineGift;
    solicitationCode;
    solicitation;
    behalfHonorMemorial;
    matchingGift;
    ukFirstGift;
    divFirstGift;
    idSorter;
    combinedDonorName;
    combinedDonorSalutation;
    combinedDonorSort;
    donor1Id;
    donor1GiftKey;
    donor1Name;
    donor1Deceased;
    donor1Constituency;
    donor1TitleBar;
    donor1Pm;
    donor1Degrees;
    donor2Id;
    donor2GiftKey;
    donor2Name;
    donor2Deceased;
    donor2Constituency;
    donor2TitleBar;
    donor2Pm;
    donor2Degrees;
    donor1Relation;
    donor2Relation;
    transmittalSn;
    sapDocNum;
    sapDocDate;
    jvDocNum;
    jvDocDate;
    advFeeCcPhil;
    advFeeAmtPhil;
    advFeeCcUnit;
    advFeeAmtUnit;
    advFeeStatus;
    hcUnit;
    createdAt;
    text() {
        return `${this.combinedAmount} from ${this.combinedDonorName} to ${this.comment ?? "Unknown"}`;
    }
    getUniqueId() {
        return this.id.id;
    }
    static init(init) {
        return DailyDepartmentNotificationNode_1.createInstance().withValues(init);
    }
};
__decorate([
    Field(() => GlobalIdScalar, { nullable: false }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationNode.prototype, "id", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "division", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "department", void 0);
__decorate([
    Field(() => GraphQLLocalDate, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "effectiveDate", void 0);
__decorate([
    Field(() => GraphQLLocalDate, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "processDate", void 0);
__decorate([
    Field(() => GraphQLLocalDate, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "pledgedDate", void 0);
__decorate([
    Field(() => GraphQLLocalDate, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "transactionDate", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "transactionType", void 0);
__decorate([
    Field(() => Number, { nullable: true }),
    __metadata("design:type", Number)
], DailyDepartmentNotificationNode.prototype, "donor1Amount", void 0);
__decorate([
    Field(() => Number, { nullable: true }),
    __metadata("design:type", Number)
], DailyDepartmentNotificationNode.prototype, "donor2Amount", void 0);
__decorate([
    Field(() => Number, { nullable: false }),
    __metadata("design:type", Number)
], DailyDepartmentNotificationNode.prototype, "combinedAmount", void 0);
__decorate([
    Field(() => Number, { nullable: false }),
    __metadata("design:type", Number)
], DailyDepartmentNotificationNode.prototype, "pledgedAmount", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "accountNumber", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "accountName", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "holdingDestination", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "comment", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "secShares", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "secType", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "gikType", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "gikDescription", void 0);
__decorate([
    Field(() => Boolean, { nullable: false }),
    __metadata("design:type", Boolean)
], DailyDepartmentNotificationNode.prototype, "onlineGift", void 0);
__decorate([
    Field(() => SolicitationCodeNode, { nullable: false }),
    __metadata("design:type", SolicitationCodeNode)
], DailyDepartmentNotificationNode.prototype, "solicitationCode", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "solicitation", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "behalfHonorMemorial", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "matchingGift", void 0);
__decorate([
    Field(() => Boolean, { nullable: false }),
    __metadata("design:type", Boolean)
], DailyDepartmentNotificationNode.prototype, "ukFirstGift", void 0);
__decorate([
    Field(() => Boolean, { nullable: false }),
    __metadata("design:type", Boolean)
], DailyDepartmentNotificationNode.prototype, "divFirstGift", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "idSorter", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "combinedDonorName", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "combinedDonorSalutation", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "combinedDonorSort", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "donor1Id", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "donor1GiftKey", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "donor1Name", void 0);
__decorate([
    Field(() => Boolean, { nullable: true }),
    __metadata("design:type", Boolean)
], DailyDepartmentNotificationNode.prototype, "donor1Deceased", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "donor1Constituency", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "donor1TitleBar", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "donor1Pm", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "donor1Degrees", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "donor2Id", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "donor2GiftKey", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "donor2Name", void 0);
__decorate([
    Field(() => Boolean, { nullable: true }),
    __metadata("design:type", Boolean)
], DailyDepartmentNotificationNode.prototype, "donor2Deceased", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "donor2Constituency", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "donor2TitleBar", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "donor2Pm", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "donor2Degrees", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "donor1Relation", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "donor2Relation", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "transmittalSn", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "sapDocNum", void 0);
__decorate([
    Field(() => GraphQLLocalDate, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "sapDocDate", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "jvDocNum", void 0);
__decorate([
    Field(() => GraphQLLocalDate, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "jvDocDate", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "advFeeCcPhil", void 0);
__decorate([
    Field(() => Number, { nullable: true }),
    __metadata("design:type", Number)
], DailyDepartmentNotificationNode.prototype, "advFeeAmtPhil", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "advFeeCcUnit", void 0);
__decorate([
    Field(() => Number, { nullable: true }),
    __metadata("design:type", Number)
], DailyDepartmentNotificationNode.prototype, "advFeeAmtUnit", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "advFeeStatus", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", String)
], DailyDepartmentNotificationNode.prototype, "hcUnit", void 0);
__decorate([
    Field(() => DateTimeScalar, { nullable: false }),
    __metadata("design:type", Function)
], DailyDepartmentNotificationNode.prototype, "createdAt", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", String)
], DailyDepartmentNotificationNode.prototype, "text", null);
DailyDepartmentNotificationNode = DailyDepartmentNotificationNode_1 = __decorate([
    ObjectType()
], DailyDepartmentNotificationNode);
export { DailyDepartmentNotificationNode };
let DailyDepartmentNotificationBatchNode = DailyDepartmentNotificationBatchNode_1 = class DailyDepartmentNotificationBatchNode extends Resource {
    id;
    batchNumber;
    batchType() {
        return extractDDNBatchType(this.batchNumber).unwrap();
    }
    getUniqueId() {
        return this.id.id;
    }
    text() {
        return `Batch ${this.batchNumber}`;
    }
    static init(init) {
        return DailyDepartmentNotificationBatchNode_1.createInstance().withValues(init);
    }
};
__decorate([
    Field(() => GlobalIdScalar, { nullable: false }),
    __metadata("design:type", Object)
], DailyDepartmentNotificationBatchNode.prototype, "id", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", String)
], DailyDepartmentNotificationBatchNode.prototype, "batchNumber", void 0);
__decorate([
    Field(() => BatchType, { nullable: false }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", String)
], DailyDepartmentNotificationBatchNode.prototype, "batchType", null);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", String)
], DailyDepartmentNotificationBatchNode.prototype, "text", null);
DailyDepartmentNotificationBatchNode = DailyDepartmentNotificationBatchNode_1 = __decorate([
    ObjectType({ implements: [Node] })
], DailyDepartmentNotificationBatchNode);
export { DailyDepartmentNotificationBatchNode };
//# sourceMappingURL=DailyDepartmentNotification.js.map